import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardFlexWrapper } from './PropertyCardFlexWrapper.styles';

/**
 * A container for custom content that appears after the data areas of a `PropertyCard`.
 *
 * @since 8.63.0
 */
export var PropertyCardFlexWrapper = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardFlexWrapper, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardFlexWrapper.displayName = 'PropertyCard.FlexWrapper';